import React from "react"
import classname from "classnames"
import PropTypes from "prop-types"
import _reduce from "lodash/reduce"
import ThemeConsumer from "shared/components/ThemeConsumer"

import { presetKeysClasses } from "./preset"
import { useChangeClassElement } from "hooks/useChangeClassElement"

const TypographTheme = ({ preset, ...props }) => {
  const themeFromPreset = {
    link: "UILinkText",
    item: "UITypoItem",
    subitem: "UITypoSubitem"
  }

  const themeValue = themeFromPreset[preset] || "UITypograph"

  const TypographWithProps = (propsTheme) => (
    <Typograph
      keyClassesDefault={presetKeysClasses[preset]}
      {...props}
      preset={preset}
      {...propsTheme}
    />
  )

  const Component = ThemeConsumer(themeValue)(TypographWithProps)

  return <Component />
}

const Typograph = ({
  children,
  htmlTag: HtmlTag = "span",
  size,
  color,
  theme,
  classNames,
  weight,
  keyClassesDefault,
  isActive,
  ...props
}) => {
  const sizeClass = theme[`text_${size}`]
  const colorClass = theme[`text_color_${color}`]
  const fontWeight = theme[`text_weight_${weight}`]
  const themeActive = theme.active
  const ref = useChangeClassElement(isActive, themeActive)

  const classesDefault = _reduce(
    keyClassesDefault,
    (acc, keyClass) => {
      const classOnTheme = theme[keyClass]

      if (classOnTheme) acc = `${classOnTheme} ${acc}`

      return acc
    },
    ""
  )

  const textClasses = classname(
    sizeClass,
    colorClass,
    fontWeight,
    classesDefault,
    classNames
  )

  return (
    <HtmlTag ref={ref} className={textClasses} {...props}>
      {children}
    </HtmlTag>
  )
}

TypographTheme.propTypes = {
  preset: PropTypes.string
}

Typograph.propTypes = {
  children: PropTypes.node,
  htmlTag: PropTypes.string,
  theme: PropTypes.object,
  size: PropTypes.string,
  color: PropTypes.string,
  classNames: PropTypes.string,
  weight: PropTypes.string,
  keyClassesDefault: PropTypes.arrayOf(PropTypes.string),
  preset: PropTypes.string,
  isActive: PropTypes.bool
}

export default TypographTheme



// WEBPACK FOOTER //
// ./src/components/Typograph/index.js